module.exports = __webpack_public_path__ + "static/img/tit2.87c4c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tit2.png
// module id = wCXX
// module chunks = 1